var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70289 5.78752L10 9.93609M10 9.93609L18.2972 5.78752M10 9.93609L10 20.0161M5.71431 3.50752L14.2857 7.79324M10.7629 1.75038L17.62 5.17895C17.9056 5.32087 18.146 5.53966 18.3141 5.8107C18.4822 6.08175 18.5713 6.39431 18.5715 6.71324V14.8818C18.5713 15.2007 18.4822 15.5133 18.3141 15.7843C18.146 16.0554 17.9056 16.2742 17.62 16.4161L10.7629 19.8447C10.5247 19.9638 10.2621 20.0259 9.99574 20.0259C9.72942 20.0259 9.46677 19.9638 9.2286 19.8447L2.37146 16.4161C2.08614 16.2723 1.84667 16.0517 1.68008 15.7791C1.51348 15.5065 1.42638 15.1927 1.4286 14.8732V6.71324C1.42877 6.39431 1.5179 6.08175 1.68598 5.8107C1.85406 5.53966 2.09442 5.32087 2.38003 5.17895L9.23717 1.75038C9.47422 1.63259 9.73533 1.57129 10 1.57129C10.2647 1.57129 10.5258 1.63259 10.7629 1.75038Z",
    stroke: "#1F3DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalSelect);
export default __webpack_public_path__ + "static/media/vertical_select.3461036462daefe45ca5a9818d304d3e.svg";
export { ForwardRef as ReactComponent };